import jsonToExcel from '@/components/services/jsonToExcel'
export const main = (filters) => [
  {text: '', value: 'actions', width: 100},
  // { text: 'ID', align: 'start', value: 'id', width: '5rem',  
  //     filter: value => {
  //                 if ( !filters.find(x=>x.name === 'id')?.value) return true
  //                 return value == filters.find(x=>x.name === 'id')?.value
  //     }
  // },
  // { text: 'Tháng khởi tạo', align: 'start', value: 'employeeReadyReviewMonth', width: '7rem',
  //     filter: value => true
  // },
  
  { text: 'ID', align: 'start', value: 'id', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.id === 'type')?.value) return true
        return value?.includes(filters.find(x=>x.id == 'type')?.value)
      }
  },
  { text: 'Store Alias', align: 'start', value: 'storeAlias', width: '7rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'storeAlias')?.value) return true
        return value.includes(filters.find(x=>x.name === 'storeAlias')?.value)
      }
  },
  { text: 'Tên Store', align: 'start', value: 'storeName', width: '10rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'storeName')?.value) return true
        return value.includes(filters.find(x=>x.name === 'storeName')?.value)
      }
  },
  { text: 'AM', align: 'start', value: 'asmCode', width: '7rem',
      filter: value => true
  },
  { text: 'AM', align: 'start', value: 'asmName', width: '7rem',
      filter: value => true
  },
  { text: 'RM', align: 'start', value: 'rsmCode', width: '7rem',
      filter: value => true
  },
  { text: 'RM', align: 'start', value: 'rsmName', width: '7rem',
      filter: value => true
  },

  { text: 'SO', align: 'start', value: 'soCode', width: '7rem',
      filter: value => true
  },
  { text: 'SO', align: 'start', value: 'soName', width: '7rem',
      filter: value => true
  },
  
  { text: 'RO', align: 'start', value: 'roCode', width: '7rem',
      filter: value => true
  },
  { text: 'RO', align: 'start', value: 'roName', width: '7rem',
      filter: value => true
  },
]
export const templateImport = (date) => {

    const formatMap = {
      storeCode: 'Mã cửa hàng',
      storeAlias: 'Tên viết tắt cửa hàng',
      storeName: 'Tên cửa hàng',
      asmCode: 'Mã ASM',
      asmName: 'Tên ASM',
      rsmCode: 'Mã RSM',
      rsmName: 'Tên RSM',
      soCode: 'Mã SO',
      soName: 'Tên SO',
      roCode: 'Mã RO',
      roName: 'Tên RO',
      month: 'Tháng',
      description: 'Mô tả'
    }
    
    const requiredFields = ['storeAlias', 'asmCode', "rsmCode"];
    const instructionRow = Object.fromEntries(
      Object.entries(formatMap).map(([key, label]) => [
        label,
        requiredFields.includes(key) ? '✅ Bắt buộc' : '',
      ]),
    );
    jsonToExcel([instructionRow], 'template_AM_RM');
}

export const importData =() => {
  return true
}